import {Box, Button, DialogActions} from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import {theme} from "../../../../../_fri/themes/theme";

interface IModalPaymentExpired {
    close: () => void,
}

export const EcommerceDashboardModalPaymentExpired = ({close}:IModalPaymentExpired) => {
    return (
        <>
            <Box sx={{marginTop: "2rem", marginBottom: "0.7rem"}}>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <AccessTimeRoundedIcon color='error' sx={{fontSize:"7rem"}}/>
                </Box>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <Box sx={{textAlign: "center", color: theme.palette.common.black}}>
                        <Box>
                            Se llego al tiempo limite, por favor
                        </Box>
                        <Box>
                            realiza nuevamente el cobro
                        </Box>
                    </Box>
                </Box>
            </Box>
            <DialogActions sx={{justifyContent: "center", marginBottom: "1rem"}}>
                <Button
                    sx={{
                        width: "6.5rem",
                        height: "3rem",
                        borderRadius: "0.5rem",
                    }}
                    color={"error"}
                    variant={"contained"}
                    onClick={close}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </>
    );
};